// extracted by mini-css-extract-plugin
module.exports = {"adService_medpro_2":"style_adService_medpro_2__1gxHp","containerService":"style_containerService__AtHz1","content":"style_content__KccyH","button":"style_button__3SiVM"};